import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api/api";

export default function Registro() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function handleRegister(e) {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      await api.post("/auth/create-user", form);
      alert("Cadastro concluído com sucesso! 🔥");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.detail || "Erro ao registrar técnico.");
    } finally { setIsLoading(false); }
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#070913] relative overflow-hidden">
      {/* Glow Effects de Fundo */}
      <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-indigo-600/10 blur-[120px] rounded-full pointer-events-none"></div>
      <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-cyan-500/5 blur-[100px] rounded-full pointer-events-none"></div>

      <div className="w-full max-w-md p-10 bg-slate-900/60 backdrop-blur-2xl rounded-[40px] border border-white/10 shadow-2xl animate-in fade-in slide-in-from-bottom-8 duration-700 relative z-10">
        <div className="text-center mb-10">
          <div className="w-20 h-20 bg-gradient-to-br from-indigo-500 to-indigo-700 rounded-3xl mx-auto mb-6 flex items-center justify-center text-white text-2xl font-black shadow-xl shadow-indigo-500/20">
            
          </div>
          <h2 className="text-3xl font-black text-white uppercase tracking-tighter">Novo <span className="text-indigo-400">Técnico</span></h2>
          <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.3em] mt-2">Credenciamento de Segurança</p>
        </div>

        <form onSubmit={handleRegister} className="space-y-5">
          <div className="space-y-1">
            <label className="text-[9px] font-black text-indigo-400 uppercase ml-2 tracking-widest">Nome Completo</label>
            <input type="text" placeholder="Ex: Luiz Kauan" required className="w-full p-4 bg-slate-950/50 border border-white/5 rounded-2xl text-white font-bold outline-none focus:border-indigo-500 focus:ring-4 ring-indigo-500/10 transition-all" onChange={e => setForm({...form, name: e.target.value})} />
          </div>

          <div className="space-y-1">
            <label className="text-[9px] font-black text-indigo-400 uppercase ml-2 tracking-widest">E-mail Corporativo</label>
            <input type="email" placeholder="tecnico@gmail.com" required className="w-full p-4 bg-slate-950/50 border border-white/5 rounded-2xl text-white font-bold outline-none focus:border-indigo-500 focus:ring-4 ring-indigo-500/10 transition-all" onChange={e => setForm({...form, email: e.target.value})} />
          </div>

          <div className="space-y-1">
            <label className="text-[9px] font-black text-indigo-400 uppercase ml-2 tracking-widest">Senha de Acesso</label>
            <input type="password" placeholder="••••••••" required className="w-full p-4 bg-slate-950/50 border border-white/5 rounded-2xl text-white font-bold outline-none focus:border-indigo-500 focus:ring-4 ring-indigo-500/10 transition-all" onChange={e => setForm({...form, password: e.target.value})} />
          </div>

          {error && <p className="text-rose-500 text-[10px] font-black text-center uppercase tracking-widest animate-pulse">{error}</p>}

          <button disabled={isLoading} className="w-full py-5 bg-indigo-600 hover:bg-indigo-500 text-white font-black rounded-2xl shadow-lg shadow-indigo-600/20 transition-all active:scale-95 uppercase text-xs tracking-widest">
            {isLoading ? "Processando..." : "Criar Credencial 🛠️"}
          </button>
        </form>

        <div className="mt-8 text-center border-t border-white/5 pt-6">
          <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
            Já possui conta? <Link to="/login" className="text-indigo-400 hover:text-indigo-300 underline transition-colors ml-1">Fazer Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}